import { gql } from '@apollo/client'

export const GET_APPROVER_GROUPS_BY_USER = gql`
  query GetApproverGroupsByUser($input: ApproverGroupsByUserRequestInput!) {
    approverGroupsByUser(request: $input) {
      approverGroups {
        groupId
        groupName
        roleTitle
        decisionReasonCode
        decisionTypeCode
        isTriggerAutomatically
        isSendEmail
        approvers {
          approverType
          approverDescription
          isActiveApprover
          countryCodes
          markets
          productLines
          region
        }
      }
      __typename
    }
  }
`
